var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.624,
    height: 16.5,
    viewBox: "0 0 16.624 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M14.763,47.655a.4.4,0,0,0-.4.4v3.556a1.2,1.2,0,0,1-1.2,1.2H1.992a1.2,1.2,0,0,1-1.2-1.2V41.175a1.2,1.2,0,0,1,1.2-1.2H5.529a.4.4,0,0,0,0-.8H1.992a2,2,0,0,0-1.992,2V51.611a2,2,0,0,0,1.992,2H13.17a2,2,0,0,0,1.992-2V48.055A.4.4,0,0,0,14.763,47.655Zm0,0",
    transform: "translate(0 -37.614)",
    fill: "#808184",
    stroke: "#808184",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M118.941.789a1.8,1.8,0,0,0-2.549,0l-7.145,7.145a.4.4,0,0,0-.1.176L108.2,11.5A.4.4,0,0,0,108.7,12l3.392-.94a.4.4,0,0,0,.176-.1l7.145-7.145a1.8,1.8,0,0,0,0-2.549ZM110.12,8.194l5.848-5.848,1.886,1.886-5.848,5.848Zm-.377.756,1.507,1.507-2.084.577Zm9.1-5.709-.425.425L116.534,1.78l.425-.425a1,1,0,0,1,1.416,0l.47.47A1,1,0,0,1,118.845,3.241Zm0,0",
    transform: "translate(-103.938 -0.261)",
    fill: "#808184",
    stroke: "#808184",
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.6b6cdd21968f5a1ddbf8cde279e91d73.svg";
export { ForwardRef as ReactComponent };